/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { KarteListPageKarteConnectionFragmentDoc } from '../KarteListPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type JpyRange = {
  max?: number | null | undefined;
  min?: number | null | undefined;
};

export type KartenFilter = {
  addresses?: Array<JISX0402> | null | undefined;
  annualIncomeRange?: JpyRange | null | undefined;
  channels?: Array<Channel> | null | undefined;
  gender?: Gender | null | undefined;
  generation?: Array<KartenFilterUserGeneration> | null | undefined;
  hasAlreadyBeenCommentedByMe?: boolean | null | undefined;
  hasChild?: boolean | null | undefined;
  hasPartner?: boolean | null | undefined;
  hasUserComment?: boolean | null | undefined;
  investmentRange?: JpyRange | null | undefined;
  jobIDs?: Array<string | number> | null | undefined;
  loanBalanceRange?: JpyRange | null | undefined;
  monthlyInsuranceRange?: JpyRange | null | undefined;
  partnerAnnualIncomeRange?: JpyRange | null | undefined;
  savingRange?: JpyRange | null | undefined;
  totalAssetsRange?: JpyRange | null | undefined;
};

export type KartenFilterUserGeneration =
  /**
   * シンボルの先頭に数字を使うことができないので冗長だけどプレフィックス
   * https://spec.graphql.org/June2018/#sec-Names
   */
  | 'GEN_20S_OR_LOWER'
  | 'GEN_30S'
  | 'GEN_40S'
  | 'GEN_50S'
  | 'GEN_60S_OR_UPPER';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type SortKey =
  | 'KARTE_SCORE_ORIGINAL';

export type UserGender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type FetchKartenForKarteListPageQueryVariables = Exact<{
  sortedBy: Types.SortKey;
  filter?: Types.KartenFilter | null | undefined;
  first: number;
  after?: string | null | undefined;
}>;


export type FetchKartenForKarteListPageQuery = { karten: { pageInfo: { endCursor: string | null, hasNextPage: boolean }, edges: Array<{ cursor: string, node: { id: string, isLikelyToMatch: boolean, hasCommentsFromPlannersBelongingToSameBranch: boolean, userComment: string, numberOfPlannerComments: number, modifiedAt: TimeString, topics: Array<{ id: string, name: string }>, ownKartePlannerComment: { id: string } | null, user: { id: string, nickname: string, channel: Types.Channel, livingPrefecture: Types.Prefecture | null, birthYear: number | null, gender: Types.UserGender, numberOfMatch: number, address: { prefecture: string, city: string } | null }, diagnosis: { annualIncome: number, saving: number, monthlyInsurance: number, investment: number, partner: { birthYear: number, annualIncome: number } | null, children: Array<{ age: number, gender: Types.Gender }> } } }> } };


export const FetchKartenForKarteListPageDocument = gql`
    query FetchKartenForKarteListPage($sortedBy: SortKey!, $filter: KartenFilter, $first: Int!, $after: String = null) {
  karten(sortedBy: $sortedBy, filter: $filter, first: $first, after: $after) {
    ...KarteListPageKarteConnection
  }
}
    ${KarteListPageKarteConnectionFragmentDoc}`;

/**
 * __useFetchKartenForKarteListPageQuery__
 *
 * To run a query within a Vue component, call `useFetchKartenForKarteListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchKartenForKarteListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchKartenForKarteListPageQuery({
 *   sortedBy: // value for 'sortedBy'
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useFetchKartenForKarteListPageQuery(variables: FetchKartenForKarteListPageQueryVariables | VueCompositionApi.Ref<FetchKartenForKarteListPageQueryVariables> | ReactiveFunction<FetchKartenForKarteListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables>(FetchKartenForKarteListPageDocument, variables, options);
}
export function useFetchKartenForKarteListPageLazyQuery(variables?: FetchKartenForKarteListPageQueryVariables | VueCompositionApi.Ref<FetchKartenForKarteListPageQueryVariables> | ReactiveFunction<FetchKartenForKarteListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables>(FetchKartenForKarteListPageDocument, variables, options);
}
export type FetchKartenForKarteListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchKartenForKarteListPageQuery, FetchKartenForKarteListPageQueryVariables>;